import { BlockContent } from '~/components/BlockContent'

const DigitalText = ({ content }: { content: unknown[] }): React.ReactElement => {
  return (
    <div className="text-pink font-seymour ">
      <BlockContent blocks={content} />
    </div>
  )
}

export default DigitalText
